/**
 * DashboardPage Component
 * 
 * Main dashboard page
 */

export function DashboardPage() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold">Dashboard</h1>
      <p className="mt-4 text-muted-foreground">
        Bienvenido a Mishiwoof
      </p>
    </div>
  );
}
